var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotInUse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.291992C3.13895 0.291992 0 3.43094 0 7.29199C0 11.153 3.13895 14.292 7 14.292C10.8611 14.292 14 11.153 14 7.29199C14 3.43094 10.8611 0.291992 7 0.291992ZM1.54737 7.29199C1.54737 6.06883 1.96 4.93404 2.63792 4.02041L10.2716 11.6541C9.35795 12.3467 8.22318 12.7446 7.00003 12.7446C3.99371 12.7446 1.54739 10.2983 1.54739 7.29202L1.54737 7.29199ZM11.3621 10.5636L3.72842 2.92989C4.64208 2.23736 5.77684 1.83941 7 1.83941C10.0063 1.83941 12.4526 4.28576 12.4526 7.29205C12.4526 8.5152 12.0547 9.64999 11.3622 10.5636L11.3621 10.5636Z",
    fill: "#636F7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotInUse);
export default __webpack_public_path__ + "static/media/NotInUse.2fa9840c0a8d3794fcd0518f2be07cd1.svg";
export { ForwardRef as ReactComponent };